import { defineComponent as _defineComponent } from 'vue'
import ProductUserHelpDownloads from '~/components/sections/productSection/ProductUserHelpDownloads.vue';
import ProductUserHelpVideos from '~/components/sections/productSection/ProductUserHelpVideos.vue';
import type { DocumentItem } from '@webplatform/frontkit/dist/types';

interface Props {
  manuals?: DocumentItem[];
  videos?: DocumentItem[];
  faqItems?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductUserHelp',
  props: {
    manuals: { default: () => [] },
    videos: { default: () => [] },
    faqItems: { default: () => [] }
  },
  setup(__props: any) {



return { __sfc: true,ProductUserHelpDownloads, ProductUserHelpVideos }
}

})